import { createSlice } from '@reduxjs/toolkit';
import { 
  fetchCryptoCurrencies, 
  fetchNetworksByCrypto, 
  validateWallet 
} from './CriptoWallet.thunk';

const initialState = {
  cryptoCurrencies: [],
  networks: [],
  cryptoWallets: [],
  selectedWallet: null,
  isFormMode: false,
  isEditMode: false,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  statusNetworks: "idle",
  errorNetworks: null,
};

const criptoWalletSlice = createSlice({
  name: 'criptoWallet',
  initialState,
  reducers: {
    setCryptoWallets: (state, action) => {
      state.cryptoWallets = action.payload;
    },
    addCryptoWallet: (state, action) => {
      state.cryptoWallets.push(action.payload);
    },
    updateCryptoWallet: (state, action) => {
      const index = state.cryptoWallets.findIndex(wallet => wallet.id === action.payload.id);
      if (index !== -1) {
        state.cryptoWallets[index] = action.payload;
      }
    },
    removeCryptoWallet: (state, action) => {
      state.cryptoWallets = state.cryptoWallets.filter(wallet => wallet.id !== action.payload);
    },
    setSelectedWallet: (state, action) => {
      state.selectedWallet = action.payload;
    },
    setIsFormMode: (state, action) => {
      state.isFormMode = action.payload;
    },
    setIsEditMode: (state, action) => {
      state.isEditMode = action.payload;
    },
    clearForm: (state) => {
      state.selectedWallet = null;
      state.isFormMode = false;
      state.isEditMode = false;
    },
    clearNetworks: (state) => {
      state.networks = [];
    },
    resetStore: (state) => {
      state = { ...initialState };
    }
  },
  extraReducers: (builder) => {
    builder
      // fetchCryptoCurrencies
      .addCase(fetchCryptoCurrencies.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCryptoCurrencies.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cryptoCurrencies = action.payload;
        state.error = null;
      })
      .addCase(fetchCryptoCurrencies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action?.payload?.message || "Error fetching crypto currencies";
      })
      // fetchNetworksByCrypto
      .addCase(fetchNetworksByCrypto.pending, (state) => {
        state.statusNetworks = "loading";
        state.errorNetworks = null;
      })
      .addCase(fetchNetworksByCrypto.fulfilled, (state, action) => {
        state.statusNetworks = "succeeded";
        state.networks = action.payload;
        state.errorNetworks = null;
      })
      .addCase(fetchNetworksByCrypto.rejected, (state, action) => {
        state.statusNetworks = "failed";
        state.errorNetworks = action?.payload?.message || "Error fetching networks";
      })
      // validateWallet
      .addCase(validateWallet.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(validateWallet.fulfilled, (state) => {
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(validateWallet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action?.payload?.message || "Error validating wallet";
      });
  }
});

export const {
  setCryptoWallets,
  addCryptoWallet,
  updateCryptoWallet,
  removeCryptoWallet,
  setSelectedWallet,
  setIsFormMode,
  setIsEditMode,
  clearForm,
  clearNetworks,
  resetStore
} = criptoWalletSlice.actions;

export default criptoWalletSlice.reducer;